import { styled } from 'stitches.config'

export const TabContentRoot = styled('div', {
  '@bp2': {
    paddingTop: '$2',
  },
})

export const Answer = styled('div', {
  marginBottom: '$2',

  '& a': {
    color: '$primary-500',

    '&:hover': {
      color: '$primary-300',
    },

    '&:active': {
      color: '$primary-600',
    },
  },

  '& p:not(:last-child)': {
    marginBottom: '$2',
  },

  '@bp2': {
    marginBottom: '$3',
  },
})
